import serverCall from "../../serverCall";

const SendCommonNotification = async (title, body) => {
  const response = await serverCall.post(
    `/race/send-notification/admin?title=${title}&body=${body}`
  );
  return response;
};

const SendIndividualNotification = async (title, body, type) => {
  const response = await serverCall.post(
    `/race/send-predict-notification/admin?title=${title}&body=${body}&type=${type}`
  );
  return response;
};

const NotificationService = {
  SendCommonNotification,
  SendIndividualNotification,
};

export default NotificationService;
